/* eslint-disable @reatom/unit-naming-rule */
import { action, atom } from '@reatom/framework'
import { BigNumber } from 'bignumber.js'

import { NumberUtil } from '@root/shared/core'

import { Pair } from '../model'

type Dto = {
  holding: string
  count: string
}
const parseHolders = (dto: Dto) => {
  return {
    count: NumberUtil.safeParseFloat(dto.count) ?? 0,
    holding: BigNumber(dto.holding),
  }
}

export const reatomPairHolders = (holders: Dto, name: string) => {
  const holdersAtom = atom<Pair.PairHolders>(parseHolders(holders), name)

  const updateHoldersAction = action(
    (ctx, holders: Partial<Pair.PairHolders>) => {
      const currentHolders = ctx.get(holdersAtom)
      const updatedHolders: Pair.PairHolders = {
        ...currentHolders,
        ...holders,
      }
      if (!Pair.eqHolders(currentHolders, updatedHolders)) {
        holdersAtom(ctx, updatedHolders)
      }
    },
  )

  const updateFromDtoAction = action((ctx, dto: Dto) => {
    updateHoldersAction(ctx, parseHolders(dto))
  })

  return {
    atom: holdersAtom,
    updateHolders: updateHoldersAction,
    updateFromDto: updateFromDtoAction,
  }
}
